import React, { useState } from "react";
import { useRoute } from "@react-navigation/native";
import { View, Text, TouchableOpacity, StyleSheet, Platform, ScrollView, Dimensions } from "react-native";	
import HeaderBar, { useScrollHide } from '../../Widgets/HeaderBar';
import { HEADER_PADDING } from '../../constants';

const { width } = Dimensions.get('window');
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
const isSmallDesktop = width >= 1024 && width <= 1440;
const deviceType = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';	

const Checklist = () => {
	const route = useRoute();
	const { type } = route.params || {}; // No default type

	const { headerTranslateY, onScroll } = useScrollHide('scrollView');

	// Firebase Storage URL configuration
	const FIREBASE_STORAGE_BASE = "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o";
	
	// Checklist paths (URL encoded for Firebase Storage)
	const checklistPaths = {
		dorm: `${FIREBASE_STORAGE_BASE}/pdfs%2FMy%20College%20Dorm%20Checklist.pdf?alt=media`,
		apartment: `${FIREBASE_STORAGE_BASE}/pdfs%2FMy%20First%20Apartment%20Checklist.pdf?alt=media`,
		graduation: `${FIREBASE_STORAGE_BASE}/pdfs%2FMy%20Graduation%20Party%20Checklist.pdf?alt=media`,
	};

	// State to manage the active checklist
	const [activeChecklist, setActiveChecklist] = useState(type || "dorm");

	// Function to render tabs
	const renderTabs = () => (
		<View style={styles.tabsContainer}>
			{Object.keys(checklistPaths).map((checklistKey) => (
				<TouchableOpacity key={checklistKey} style={[styles.tab, activeChecklist === checklistKey && styles.activeTab]} onPress={() => setActiveChecklist(checklistKey)}>
					<Text style={styles.tabText}>{checklistKey.charAt(0).toUpperCase() + checklistKey.slice(1)}</Text>
				</TouchableOpacity>
			))}
		</View>
	);

	// Determine the PDF file URL based on the active tab
	const pdfFileUrl = checklistPaths[activeChecklist];

	return (
		<View style={styles.container}>
			<HeaderBar headerTranslateY={headerTranslateY} />
			<View style={{ paddingTop: isMobile ? HEADER_PADDING.mobile : isTablet ? HEADER_PADDING.tablet : HEADER_PADDING.desktop }}>
			{renderTabs()}
			</View>
			<ScrollView style={{ flex: 1 }} onScroll={onScroll} scrollEventThrottle={16} contentContainerStyle={{ paddingTop: 10 }}>
				{Platform.OS === "web" ? (
					<iframe src={pdfFileUrl} style={styles.pdf} frameBorder="0">
						Your browser does not support iframes.
					</iframe>
				) : (
					<Text>PDF display is not supported on this platform.</Text>
				)}
			</ScrollView>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
		width: "100%",
		height: "100vh",
		backgroundColor: "#4c956c",
	},
	tabsContainer: {
		flexDirection: "row",
		justifyContent: "center",
	},
	tab: {
		padding: 10,
		marginHorizontal: 5,
		borderBottomWidth: 2,
		borderBottomColor: "transparent",
	},
	activeTab: {
		borderBottomColor: "#007bff",
	},
	tabText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize: 25,
		lineHeight: 30,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	pdf: {
		width: "100%",
		height: "100vh",
		minHeight: 500,
	},
});

export default Checklist;
